const serviceMenu = (permissions, profileType, role, additionalObject) => {
  const { licensingStatus } = additionalObject;

  return [
    {
      id: "profileManagement",
      name: "Profile Management",
      path: "/aceas/profile-management",
      iconUrl: "user-o",
      meta: {
        requiresAuth: true,
        isShow: permissions,
        entity: "/profile"
      },
      childs: [
        {
          id: "profile",
          name: "Profile",
          path: "/aceas/profile-management",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/profile"
          }
        },
        {
          id: "member-list",
          name: "Member List",
          path: "/aceas/profile-management/member-information/keo",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity:
              profileType == 1 &&
              (licensingStatus == "Licensed" ||
                licensingStatus == "Applying New Licence" ||
                licensingStatus === "Licensed (KEO Removed)")
                ? "/profile"
                : "null"
          }
        },
        {
          id: "pii-information",
          name: "PII Information",
          path: "/aceas/profile-management/PII-information",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: profileType == 1 ? "/profile" : "null"
          }
        },
        {
          id: "gst-refund",
          name: "GST Refund",
          path: "/aceas/profile-management/GST-refund",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/profile/profile-application-transaction"
          }
        }
      ]
    },
    {
      id: "payment",
      name: "Payment",
      path: "/aceas/my-payments",
      iconUrl: "usd",
      meta: {
        requiresAuth: true,
        isShow: permissions,
        entity: "/pay"
      },
      childs: []
    },
    {
      id: "1",
      name: "Workspace",
      path: "/aceas",
      iconUrl: "thermometer-full",
      meta: {
        requiresAuth: true,
        isShow: permissions
      },
      childs: []
    },
    {
      id: "feedback-management",
      name: "Feedback Management",
      path: "/aceas/feedback-management",
      description: "Feedback management module",
      iconUrl: "commenting-o",
      meta: {
        requiresAuth: true,
        isShow: permissions
      },
      childs: [
        {
          id: "feedback",
          name: "Feedback",
          path: "/aceas/feedback-management",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/feedback"
          }
        },
        {
          id: "complaint",
          name: "Complaint",
          path: "/aceas/feedback-management/complaint",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/complaint"
          }
        }
      ]
    },
    {
      id: "3",
      name: "Circulars",
      description: "Circulars management module",
      iconUrl: "envelope-o",
      path: "/aceas/circulars-list",
      meta: {
        requiresAuth: true,
        isShow: permissions,
        entity: "/circular"
      },
      childs: []
    },
    {
      id: "4",
      name: "RES Exam Management",
      path: "/aceas/RES-exam-management",
      iconUrl: "file-text-o",
      meta: {
        requiresAuth: true,
        isShow: permissions
      },
      childs: [
        {
          id: "exam-list",
          name: "Exam List",
          path: "/aceas/RES-exam-management/exam-list",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/exam/res-exam/exam-list"
          }
        },
        {
          id: "application-list",
          name: "RES Exam Applications",
          path: "/aceas/RES-exam-management/application",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/exam/res-exam/exam-app-list"
          }
        },
        {
          id: "deferment",
          name: "Deferment",
          path: "/aceas/RES-exam-management/deferment",
          meta: {
            // ACEAS2-5097 - disable relevant action -> exclude from prod
            // uat and dev for testing purposes
            envExclusion: ["prd", "uat", "dev"],
            requiresAuth: true,
            isShow: permissions,
            entity: "/exam/res-exam/deferment-list"
          }
        },
        {
          id: "appeals",
          name: "Appeals",
          path: "/aceas/RES-exam-management/appeal",
          meta: {
            // ACEAS2-5097 - disable relevant action -> exclude from prod
            // uat and dev for testing purposes
            envExclusion: ["prd", "uat", "dev"],
            requiresAuth: true,
            isShow: permissions,
            entity: role.includes("aea") ? "/aea" : "/exam/res-exam/appeal-list"
          }
        }
      ]
    },
    {
      id: "5",
      name: "REA Exam Management",
      path: "/aceas/REA-exam-management",
      iconUrl: "file-text-o",
      meta: {
        requiresAuth: true,
        isShow: permissions
      },
      childs: [
        {
          id: "exam-list",
          name: "Exam List",
          path: "/aceas/REA-exam-management/exam-list",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/exam/rea-exam/exam-list"
          }
        },
        {
          id: "application",
          name: "REA Exam Applications",
          path: "/aceas/REA-exam-management/application",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/exam/rea-exam/exam-app-list"
          }
        },
        {
          id: "deferment",
          name: "Deferments",
          path: "/aceas/REA-exam-management/deferment",
          meta: {
            // ACEAS2-5097 - disable relevant action -> exclude from prod
            // uat and dev for testing purposes
            envExclusion: ["prd", "uat", "dev"],
            requiresAuth: true,
            isShow: permissions,
            entity: "/exam/rea-exam/deferment-list"
          }
        },
        {
          id: "appeals",
          name: "Appeals",
          path: "/aceas/REA-exam-management/appeal",
          meta: {
            // ACEAS2-5097 - disable relevant action -> exclude from prod
            // uat and dev for testing purposes
            envExclusion: ["prd", "uat", "dev"],
            requiresAuth: true,
            isShow: permissions,
            entity: role.includes("aea") ? "/aea" : "/exam/rea-exam/appeal-list"
          }
        }
      ]
    },
    {
      id: "6",
      name: "RES Management",
      path: "/aceas/RES-Management",
      iconUrl: "pencil-square-o",
      meta: {
        requiresAuth: true,
        isShow: permissions
      },
      childs: [
        {
          id: "new-and-returning",
          name: "New and Returning",
          path: "/aceas/RES-Management/new-and-returning",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/app/res-new-app"
          }
        },
        {
          id: "switching",
          name: "Switching",
          path: "/aceas/RES-Management/switching",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/app/res-switch-app"
          }
        },
        {
          id: "renewal",
          name: "Renewal",
          path: "/aceas/RES-Management/renewal",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/app/res-renewal-app"
          }
        },
        {
          id: "cancellation",
          name: "Cancellation",
          path: "/aceas/RES-Management/cancellation",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/app/res-cancel-app"
          }
        }
      ]
    },
    {
      id: "8",
      name: "EA Management",
      path: "/aceas/EA-Management",
      iconUrl: "id-card-o",
      meta: {
        requiresAuth: true,
        isShow: permissions
      },
      childs: [
        {
          id: "new",
          name: "EA Licence (New)",
          path: "/aceas/EA-Management/new-EA-licence-application",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/app/ea-new-app"
          }
        },
        {
          id: "renewal",
          name: "Renewal",
          path:
            profileType == 1
              ? "/aceas/EA-Management/EA-licence-renewal"
              : "/aceas/EA-Management/director-partner-renewal",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/app/ea-renewal-app"
          }
        },
        {
          id: "cancellation",
          name: "Cancellation",
          path: "/aceas/EA-Management/cancellation",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/app/ea-cancel-app"
          }
        },
        {
          id: "addition-removal-keo",
          name: "Addition/Removal of KEO",
          path: "/aceas/EA-Management/addition-of-KEO",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/app/ea-keo-app"
          }
        },
        {
          id: "addition-removal-dp",
          name: "Addition/Removal of Director/Partner",
          path: "/aceas/EA-Management/addition-of-director-partner-application",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/app/ea-dir-partner-app"
          }
        },
        profileType == 1
          ? {
              id: "ptr",
              name: "Property Transaction Record",
              path:
                "/aceas/EA-Management/property-transaction-record-management",
              meta: {
                requiresAuth: true,
                isShow: permissions,
                entity: "/property-txn"
              }
            }
          : {
              // This will not be rendered on global menu
              meta: {
                entity: null
              }
            }
      ]
    },
    {
      id: "10",
      name: "Pre-application",
      path: "/aceas/pre-application",
      iconUrl: "file-o",
      meta: {
        requiresAuth: true,
        isShow: permissions,
        entity: "/app/pre-app"
      },
      childs: []
    },
    {
      id: "7",
      name: "PII Management",
      path: "/aceas/PII-management",
      iconUrl: "user-circle",
      meta: {
        requiresAuth: true,
        isShow: permissions
      },
      childs: [
        {
          id: "pii-uploader",
          name: "PII Information Uploader",
          path: "/aceas/PII-management/PII-information-uploader",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/profile/pii-broker"
          }
        }
      ]
    },
    {
      id: "9",
      name: "Qualification Management",
      path: "/aceas/qualification-management",
      iconUrl: "files-o",
      meta: {
        requiresAuth: true,
        isShow: permissions
      },
      childs: [
        {
          id: "assessment-qualification",
          name: "Assessment Qualification",
          path: "/aceas/qualification-management/assessment-of-qualification",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/qualification/assessment"
          }
        }
      ]
    },
    {
      id: "appeal-management",
      name: "Appeal Management",
      path: "/aceas/appeal-management",
      iconUrl: "file-o",
      meta: {
        requiresAuth: true,
        isShow: permissions
      },
      childs: [
        {
          id: "reconsideration",
          name: "Reconsideration",
          path: "/aceas/appeal-management/reconsideration",
          meta: {
            requiresAuth: true,
            isShow: permissions,
            entity: "/appeals/reconsideration"
          }
        }
      ]
    }
  ];
};

export default serviceMenu;
